import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";

import { BgLoader, PageError, UiButton } from "../../ui";

import { useNavigate, useOutletContext, useParams } from "react-router-dom";

import { Helmet } from "react-helmet";

import { CreditNoteTemplate } from '../../credit_note'


export default function CreditNote() {
  let navigate = useNavigate();
  let { id } = useParams();

  const [state, setState] = useState({});
  const [loader, showLoader] = useState(false);

  const [pstate, setTitle] = useOutletContext(); // <-- access context value



  const downloadPdf = (id, id1) => {
    showLoader(true)
    fetch('https://api.practive.in/pdf?voucher=cn&id=' + id + ':' + encodeURIComponent(id1)).then(response => {
      response.blob().then(blob => {

        const fileURL = window.URL.createObjectURL(blob);

        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'cn.pdf';
        alink.click();
        showLoader(false)
      })
    })
  }


  const fetchData = () => {
    instance
      .get("/cust_cn?id=" + id)
      .then(function (response) {

        setState({ ...state, ...response.data });

      })
      .catch(function (error) { })
      .then(function () { });

  }


  useEffect(() => {
    setTitle('Credit Note')
    fetchData()
  }, []);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }



  return (
    <div className="mt-2">
      <Helmet>
        <title>Credit Note</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {state.status ? (
        <>
          <div className="card card-default mb-3">
            <div className="card-body">
              <CreditNoteTemplate data={state.voucher} />
            </div>
          </div>
          <UiButton className="btn btn-primary" onClick={() => downloadPdf(state.voucher.id, state.voucher.cn_id)} loading={loader} title="Download Credit Note"></UiButton>
        </>)
        : <BgLoader />}

    </div>
  );
}
